import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ConfigProvider } from "./context/ConfigContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import DocumentDetail from "./pages/DocumentDetail";
import MessagesPage from "./pages/MessagesPage";
import CarePlanPage from "./pages/CarePlanPage";
import CaregiversPage from "./pages/CaregiversPage";
import SchedulePage from "./pages/SchedulePage";
import SubcontractorsPage from "./pages/SubcontractorsPage";
import PropertyPage from "./pages/PropertyPage";
import PricingPage from "./pages/PricingPage";
import BillingPage from "./pages/BillingPage";
import BillingSuccessPage from "./pages/BillingSuccessPage";
import BillingCancelPage from "./pages/BillingCancelPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import AuditPacketPage from "./pages/AuditPacketPage";
import CredentialsPage from "./pages/CredentialsPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F7F4]">
        <div className="w-8 h-8 border-2 border-[#2E5C50] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <ConfigProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/dashboard"
            element={
              <Protected>
                <DashboardPage />
              </Protected>
            }
          />
          <Route
            path="/documents/:id"
            element={
              <Protected>
                <DocumentDetail />
              </Protected>
            }
          />
          <Route
            path="/messages"
            element={
              <Protected>
                <MessagesPage />
              </Protected>
            }
          />
          <Route
            path="/careplan"
            element={
              <Protected>
                <CarePlanPage />
              </Protected>
            }
          />
          <Route
            path="/caregivers"
            element={
              <Protected>
                <CaregiversPage />
              </Protected>
            }
          />
          <Route
            path="/schedule"
            element={
              <Protected>
                <SchedulePage />
              </Protected>
            }
          />
          <Route
            path="/subcontractors"
            element={
              <Protected>
                <SubcontractorsPage />
              </Protected>
            }
          />
          <Route
            path="/property"
            element={
              <Protected>
                <PropertyPage />
              </Protected>
            }
          />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route
            path="/audit-packet"
            element={
              <Protected>
                <AuditPacketPage />
              </Protected>
            }
          />
          <Route
            path="/billing"
            element={
              <Protected>
                <BillingPage />
              </Protected>
            }
          />
          <Route
            path="/billing/success"
            element={
              <Protected>
                <BillingSuccessPage />
              </Protected>
            }
          />
          <Route
            path="/billing/cancel"
            element={
              <Protected>
                <BillingCancelPage />
              </Protected>
            }
          />
          <Route
            path="/credentials"
            element={
              <Protected>
                <CredentialsPage />
              </Protected>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
